module.exports = __webpack_public_path__ + "static/media/David Sarmento.f0ff9b7e.png";